export default __webpack_public_path__ + "static/media/very-high.2ad7b421.svg";